(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 768;
  var VISIBLE_PRODUCTS = 4;

  function showLoadedImages(root) {
    root.querySelectorAll('.card-media img, .product img').forEach(function (image, index) {
      var dataSrc = image.getAttribute('data-src');
      var dataSrcset = image.getAttribute('data-srcset');

      if ((!image.getAttribute('src') || image.getAttribute('src') === 'data:,') && dataSrc) {
        image.setAttribute('src', dataSrc);
      }

      if (!image.getAttribute('srcset') && dataSrcset) {
        image.setAttribute('srcset', dataSrcset);
      }

      image.loading = index < VISIBLE_PRODUCTS ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.classList.remove('lazyload', 'lazyloading');
      image.classList.add('lazyloaded');
    });
  }

  function getProductGrid(block) {
    return block.querySelector('.products-carousel, .products-grid, .products-flex');
  }

  function setupMobileGrid(block) {
    var grid = getProductGrid(block);
    if (!grid) return;

    var products = Array.prototype.filter.call(grid.children, function (child) {
      return child.classList && child.classList.contains('product');
    });
    var existingButton = block.querySelector('[data-revent-recommendations-more]');

    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      block.classList.remove('revent-mobile-grid-active');
      products.forEach(function (product) {
        product.classList.remove('revent-recommendation-hidden');
      });
      if (existingButton) existingButton.remove();
      return;
    }

    block.classList.add('revent-mobile-grid-active');
    grid.classList.add('revent-mobile-recommendations-grid');

    products.forEach(function (product, index) {
      product.classList.toggle('revent-recommendation-hidden', index >= VISIBLE_PRODUCTS);
    });

    if (products.length <= VISIBLE_PRODUCTS || existingButton) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'revent-recommendations-more';
    button.setAttribute('data-revent-recommendations-more', '');
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'Show more';

    button.addEventListener('click', function () {
      products.forEach(function (product) {
        product.classList.remove('revent-recommendation-hidden');
      });
      button.setAttribute('aria-expanded', 'true');
      button.remove();
    });

    grid.insertAdjacentElement('afterend', button);
  }

  function prepareRecommendations(block) {
    block.classList.add('ajax-loaded', 'revent-recommendations-loaded');
    showLoadedImages(block);
    setupMobileGrid(block);
  }

  function loadRecommendations() {
    var block = document.querySelector('[data-recommendations-block]');
    if (!block || !block.dataset.url) return;

    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        var product = block.querySelector('.product-item:not(.product-item--loadingNoInfo)');
        if (product) prepareRecommendations(block);
      });
    }).observe(block, { childList: true, subtree: true });

    var realProduct = block.querySelector('.product-item:not(.product-item--loadingNoInfo)');
    if (realProduct) {
      prepareRecommendations(block);
      return;
    }

    if (block.dataset.reventRecommendationsLoading === 'true') return;
    block.dataset.reventRecommendationsLoading = 'true';

    var controller = 'AbortController' in window ? new AbortController() : null;
    var timeoutId = window.setTimeout(function () {
      if (controller) controller.abort();
      block.classList.add('revent-recommendations-failed');
      block.dataset.reventRecommendationsLoading = 'false';
    }, 10000);

    fetch(block.dataset.url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed: ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var source = html.querySelector('[data-recommendations-block]');
        var sourceProduct = source && source.querySelector('.product-item:not(.product-item--loadingNoInfo)');

        if (!source || !sourceProduct) {
          throw new Error('No product recommendations were returned.');
        }

        window.clearTimeout(timeoutId);
        block.innerHTML = source.innerHTML;
        block.classList.remove('revent-recommendations-failed');
        block.dataset.reventRecommendationsLoading = 'false';
        prepareRecommendations(block);

        document.dispatchEvent(new CustomEvent('revent:recommendations:loaded', {
          detail: { block: block }
        }));
      })
      .catch(function (error) {
        window.clearTimeout(timeoutId);
        block.dataset.reventRecommendationsLoading = 'false';

        if (error && error.name !== 'AbortError') {
          console.warn('Unable to load product recommendations', error);
        }

        block.classList.add('revent-recommendations-failed');
      });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        setupMobileGrid(block);
      }, 180);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadRecommendations, { once: true });
  } else {
    loadRecommendations();
  }

  document.addEventListener('shopify:section:load', loadRecommendations);
})();
